module.exports = __webpack_public_path__ + "static/img/pay.5a7f995.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pay.png
// module id = qoUi
// module chunks = 1